<template>
  <div class="ryvyl-form">
    <form
      :action="redirectUrl"
      class="paymentWidgets"
      data-brands="VISA MASTER AMEX"
    ></form>
    <component
      is="script"
      :src="scriptSrc"
      :integrity="integrity"
      crossorigin="anonymous"
      async
    ></component>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    scriptData: {
      type: Object,
      required: true,
      validator(data) {
        return true;
      },
    },
    paymentCountryCode: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {};
  },
  beforeMount() {
    window.wpwlOptions = {
      style: "card",
      billingAddress: {
        country: this.paymentCountryCode,
        state: "",
        city: "",
        postcode: "",
        street1: "",
        street2: "",
      },
      locale: "es",
      mandatoryBillingFields: {
        country: true,
        state: true,
        city: true,
        postcode: true,
        street1: true,
        street2: false,
      },
      // Enable brand detection
      brandDetection: true,

      // Use our internal BIN list to precisely detect brands
      brandDetectionType: "binlist",

      // Give priority to detected brands
      brandDetectionPriority: ["VISA", "AMEX", "MASTER"],
      onReady: function () {
        var createRegistrationHtml =
          '<div class="customLabel">Store payment details?</div><div class="customInput"><input type="checkbox" name="createRegistration" value="true" /></div>';
        $("form.wpwl-form-card")
          .find(".wpwl-button")
          .before(createRegistrationHtml);
      },
    };
  },
  methods: {},
  computed: {
    scriptSrc() {
      const baseUrl =
        process.env.VUE_APP_NODE_ENV === "production"
          ? "https://payments-ryvyl.eu"
          : "https://test.payments-ryvyl.eu";

      return `${baseUrl}/v1/paymentWidgets.js?checkoutId=${this.scriptData.checkoutId}/registration`;
    },
    redirectUrl() {
      return this.scriptData.url;
    },
    integrity() {
      return this.scriptData.integrity;
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss">
@import "../../../../styles/variables";
@import "../../../../styles/classes";
@import "../../../../styles/themes/chads";
</style>
